// MicrolearningList.js
import React from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import ProgressBar from '../../components/common/ProgressBar';

const MicroLearningList = ({ catalogs }) => {
    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h3 className="font-medium text-base-content">Verfügbare Lerneinheiten</h3>
                <span className="text-xs text-base-content/70">{catalogs.length} Einheiten</span>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {catalogs.map((catalog) => (
                    <div key={catalog.id} className="card bg-base-100 shadow-md ring-1 ring-base-content/5">
                        <div className="card-body p-4">
                            <div className="flex flex-col h-full">
                                {/* Header */}
                                <div className="flex items-start justify-between gap-3 mb-3">
                                    <h4 className="font-medium text-base-content">
                                        {catalog.name}
                                    </h4>
                                </div>

                                {/* Progress Bar */}
                                <div className="mb-4">
                                    <ProgressBar 
                                        green={catalog.green_questions}
                                        yellow={catalog.yellow_questions}
                                        red={catalog.red_questions}
                                        white={catalog.white_questions}
                                        total={catalog.total_questions}
                                        size="sm"
                                    />
                                </div>

                                {/* Action Buttons */}
                                <div className="mt-auto flex gap-2">
                                    <Link
                                        to={`/alle-fragen?catalog=${catalog.id}`}
                                        className="btn btn-secondary text-white btn-sm flex-1"
                                        title={`Alle ${catalog.total_questions} Fragen aus ${catalog.name} anzeigen`}
                                    >
                                        <QuestionMarkCircleIcon className="w-4 h-4" />
                                        {catalog.total_questions} Fragen
                                    </Link>
                                    <Link
                                        to={`/micro-learning/quiz/${catalog.id}`}
                                        className="btn btn-success text-white btn-sm flex-1"
                                    >
                                        <PlayIcon className="w-4 h-4" />
                                        Starten
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MicroLearningList;
